import { Grid } from '@mui/material';

import { type DocumentType, graphql } from '@/gql';

import { AssistantUserInputBubble } from './item/AssistantUserInputBubble';

import { AssistantAiResponse } from './item/AssistantAiResponse';

const ASSISTANT_CONVERSATION_ITEM_CONVERSATION_FRAGMENT = graphql(`
  fragment assistantConversationItemConversationFields on OrtooGptConversation {
    user {
      ...assistantUserInputBubbleUserFields
    }
  }
`);

const ASSISTANT_CONVERSATION_ITEM_ITEM_FRAGMENT = graphql(`
  fragment assistantConversationItemItemFields on OrtooGptConversationItem {
    ...assistantAiResponseBubbleItemFields
    prompt {
      ...assistantUserInputBubblePromptFields
    }
  }
`);

interface Props {
  conversation: DocumentType<
    typeof ASSISTANT_CONVERSATION_ITEM_CONVERSATION_FRAGMENT
  >;
  item: DocumentType<typeof ASSISTANT_CONVERSATION_ITEM_ITEM_FRAGMENT>;
}

export const AssistantConversationItem = ({ conversation, item }: Props) => {
  const { user } = conversation;
  const { prompt, response } = item;

  return (
    <Grid container direction="column" spacing={2} width="100%">
      {prompt && user && (
        <AssistantUserInputBubble prompt={prompt} user={user} />
      )}
      {response && <AssistantAiResponse item={item} />}
    </Grid>
  );
};
